import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CostReportCardEllipsisClick } from '@inventory/models/cost-report-model.model';
import { PlatformEnum } from '@panamax/app-state';
import { FoodCostReportState, FoodCostTarget } from '@usf/ngrx-inventory';

@Component({
  selector: 'app-food-cost-card',
  templateUrl: './food-cost-card.component.html',
  styleUrls: ['./food-cost-card.component.scss'],
})
export class FoodCostCardComponent {
  @Input() foodCostReport: FoodCostReportState;
  @Input() platform: PlatformEnum;

  @Output()
  ellipsisClickEmitter: EventEmitter<CostReportCardEllipsisClick> = new EventEmitter();
  @Output()
  cardClickEmitter: EventEmitter<CostReportCardEllipsisClick> = new EventEmitter();
  readonly foodCostTargetRef = FoodCostTarget;
  readonly platformEnumRef = PlatformEnum;

  constructor() {}

  onEllipsisClick(event, foodCostReport) {
    event.stopPropagation();
    this.ellipsisClickEmitter.emit({ event, foodCostReport });
  }

  onCardClick(event, foodCostReport) {
    event.stopPropagation();
    this.cardClickEmitter.emit({ event, foodCostReport });
  }
}
